export default {
  methods: {
    stripeErrorHandling: function(err) {
        if(err.response.status === 500) {
          this.noticeType = 'alert'
          this.noticeTitle = 'error'
          this.noticeText = err.response.data.err.raw.message
          this.isNotice = true
          setTimeout(this.closeNotice, 10000)
          this.loading = false
        } else if(err.response.status === 422) {
        }
    },

    closeNotice: function() {
      this.isNotice = false
    },
  }
}
